var _defs, _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _polygon6, _polygon7, _polygon8, _polygon9, _polygon10, _polygon11, _polygon12, _polygon13, _polygon14, _polygon15, _polygon16, _polygon17, _polygon18, _polygon19, _polygon20, _polygon21, _polygon22, _polygon23, _polygon24, _polygon25, _polygon26, _polygon27, _polygon28, _polygon29, _polygon30, _polygon31, _polygon32, _polygon33, _polygon34, _polygon35, _polygon36, _polygon37, _polygon38, _polygon39, _polygon40, _polygon41, _polygon42, _polygon43, _polygon44, _polygon45, _polygon46, _polygon47, _polygon48, _polygon49, _polygon50, _polygon51, _polygon52, _polygon53, _polygon54, _polygon55, _polygon56, _polygon57, _polygon58, _polygon59, _polygon60, _polygon61, _polygon62, _polygon63, _polygon64, _polygon65, _polygon66, _polygon67, _polygon68, _polygon69, _polygon70, _polygon71, _polygon72;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFrLogoNew = function SvgFrLogoNew(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    "data-name": "Ebene 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1000 1000"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f59b00;}.cls-2{fill:#fff;}.cls-3{fill:#e40124;}.cls-4{fill:#2a2b87;}"))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "166.95 333.67 333.66 166.96 166.95 166.96 166.95 333.67"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "1000.5 333.67 1000.5 166.96 833.79 333.67 1000.5 333.67"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "667.08 667.09 667.08 500.38 500.37 667.09 667.08 667.09"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "500.37 500.38 667.08 500.38 500.37 333.67 500.37 500.38"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "500.37 667.09 667.08 500.38 500.37 500.38 500.37 667.09"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "1000.5 667.09 1000.5 500.38 833.79 667.09 1000.5 667.09"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "0.24 667.09 0.24 833.8 166.95 667.09 0.24 667.09"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "333.66 1000.5 500.37 1000.5 333.66 833.8 333.66 1000.5"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "333.66 833.8 500.37 1000.5 500.37 833.8 333.66 833.8"
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "0.24 0.25 0.24 166.96 166.95 0.25 0.24 0.25"
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "166.95 0.25 0.24 166.96 166.95 166.96 166.95 0.25"
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "0.24 166.96 166.95 333.67 166.95 166.96 0.24 166.96"
  })), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "667.08 333.67 667.08 166.96 500.37 333.67 667.08 333.67"
  })), _polygon14 || (_polygon14 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "500.37 0.25 333.66 166.96 500.37 166.96 500.37 0.25"
  })), _polygon15 || (_polygon15 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "500.37 166.96 667.08 166.96 500.37 0.25 500.37 166.96"
  })), _polygon16 || (_polygon16 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "333.66 166.96 500.37 333.67 500.37 166.96 333.66 166.96"
  })), _polygon17 || (_polygon17 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "500.37 333.67 667.08 166.96 500.37 166.96 500.37 333.67"
  })), _polygon18 || (_polygon18 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "667.08 333.67 833.79 333.67 667.08 166.96 667.08 333.67"
  })), _polygon19 || (_polygon19 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "833.79 0.25 667.08 166.96 833.79 166.96 833.79 0.25"
  })), _polygon20 || (_polygon20 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "833.79 166.96 1000.5 166.96 833.79 0.25 833.79 166.96"
  })), _polygon21 || (_polygon21 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "667.08 166.96 833.79 333.67 833.79 166.96 667.08 166.96"
  })), _polygon22 || (_polygon22 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "833.79 333.67 1000.5 166.96 833.79 166.96 833.79 333.67"
  })), _polygon23 || (_polygon23 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "0.24 667.09 166.95 667.09 0.24 500.38 0.24 667.09"
  })), _polygon24 || (_polygon24 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "333.66 667.09 333.66 500.38 166.95 667.09 333.66 667.09"
  })), _polygon25 || (_polygon25 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "0.24 500.38 166.95 667.09 166.95 500.38 0.24 500.38"
  })), _polygon26 || (_polygon26 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "500.37 333.67 667.08 500.38 667.08 333.67 500.37 333.67"
  })), _polygon27 || (_polygon27 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "333.66 667.09 500.37 667.09 333.66 500.38 333.66 667.09"
  })), _polygon28 || (_polygon28 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "333.66 500.38 500.37 667.09 500.37 500.38 333.66 500.38"
  })), _polygon29 || (_polygon29 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "667.08 333.67 667.08 500.38 833.79 333.67 667.08 333.67"
  })), _polygon30 || (_polygon30 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "667.08 500.38 833.79 667.09 833.79 500.38 667.08 500.38"
  })), _polygon31 || (_polygon31 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "166.95 667.09 333.66 833.8 333.66 667.09 166.95 667.09"
  })), _polygon32 || (_polygon32 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "0.24 1000.5 166.95 1000.5 0.24 833.8 0.24 1000.5"
  })), _polygon33 || (_polygon33 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "333.66 667.09 333.66 833.8 500.37 667.09 333.66 667.09"
  })), _polygon34 || (_polygon34 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "667.08 667.09 667.08 833.8 833.79 667.09 667.08 667.09"
  })), _polygon35 || (_polygon35 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "833.79 667.09 1000.5 833.8 1000.5 667.09 833.79 667.09"
  })), _polygon36 || (_polygon36 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "667.08 1000.5 833.79 1000.5 667.08 833.8 667.08 1000.5"
  })), _polygon37 || (_polygon37 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "1000.5 1000.5 1000.5 833.8 833.79 1000.5 1000.5 1000.5"
  })), _polygon38 || (_polygon38 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "833.79 667.09 667.08 833.8 833.79 833.8 833.79 667.09"
  })), _polygon39 || (_polygon39 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "833.79 833.8 1000.5 833.8 833.79 667.09 833.79 833.8"
  })), _polygon40 || (_polygon40 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "667.08 833.8 833.79 1000.5 833.79 833.8 667.08 833.8"
  })), _polygon41 || (_polygon41 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "833.79 1000.5 1000.5 833.8 833.79 833.8 833.79 1000.5"
  })), _polygon42 || (_polygon42 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "166.95 500.38 333.66 500.38 166.95 333.67 166.95 500.38"
  })), _polygon43 || (_polygon43 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "0.24 333.67 0.24 500.38 166.95 333.67 0.24 333.67"
  })), _polygon44 || (_polygon44 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "166.95 333.67 0.24 500.38 166.95 500.38 166.95 333.67"
  })), _polygon45 || (_polygon45 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "166.95 0.25 333.66 166.96 333.66 0.25 166.95 0.25"
  })), _polygon46 || (_polygon46 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "333.66 0.25 333.66 166.96 500.37 0.25 333.66 0.25"
  })), _polygon47 || (_polygon47 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "500.37 333.67 333.66 500.38 500.37 500.38 500.37 333.67"
  })), _polygon48 || (_polygon48 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "833.79 333.67 1000.5 500.38 1000.5 333.67 833.79 333.67"
  })), _polygon49 || (_polygon49 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "833.79 500.38 1000.5 500.38 833.79 333.67 833.79 500.38"
  })), _polygon50 || (_polygon50 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "166.95 667.09 0.24 833.8 166.95 833.8 166.95 667.09"
  })), _polygon51 || (_polygon51 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "166.95 833.8 333.66 833.8 166.95 667.09 166.95 833.8"
  })), _polygon52 || (_polygon52 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "500.37 833.8 667.08 833.8 500.37 667.09 500.37 833.8"
  })), _polygon53 || (_polygon53 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "500.37 1000.5 667.08 833.8 500.37 833.8 500.37 1000.5"
  })), _polygon54 || (_polygon54 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "0.24 333.67 166.95 333.67 0.24 166.96 0.24 333.67"
  })), _polygon55 || (_polygon55 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "333.66 333.67 333.66 166.96 166.95 333.67 333.66 333.67"
  })), _polygon56 || (_polygon56 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "166.95 166.96 333.66 166.96 166.95 0.25 166.95 166.96"
  })), _polygon57 || (_polygon57 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "500.37 0.25 667.08 166.96 667.08 0.25 500.37 0.25"
  })), _polygon58 || (_polygon58 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "333.66 333.67 500.37 333.67 333.66 166.96 333.66 333.67"
  })), _polygon59 || (_polygon59 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "667.08 0.25 667.08 166.96 833.79 0.25 667.08 0.25"
  })), _polygon60 || (_polygon60 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "833.79 0.25 1000.5 166.96 1000.5 0.25 833.79 0.25"
  })), _polygon61 || (_polygon61 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "166.95 333.67 333.66 500.38 333.66 333.67 166.95 333.67"
  })), _polygon62 || (_polygon62 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "166.95 667.09 333.66 500.38 166.95 500.38 166.95 667.09"
  })), _polygon63 || (_polygon63 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "333.66 333.67 333.66 500.38 500.37 333.67 333.66 333.67"
  })), _polygon64 || (_polygon64 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "667.08 667.09 833.79 667.09 667.08 500.38 667.08 667.09"
  })), _polygon65 || (_polygon65 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "833.79 333.67 667.08 500.38 833.79 500.38 833.79 333.67"
  })), _polygon66 || (_polygon66 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "833.79 667.09 1000.5 500.38 833.79 500.38 833.79 667.09"
  })), _polygon67 || (_polygon67 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "333.66 1000.5 333.66 833.8 166.95 1000.5 333.66 1000.5"
  })), _polygon68 || (_polygon68 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "0.24 833.8 166.95 1000.5 166.95 833.8 0.24 833.8"
  })), _polygon69 || (_polygon69 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "166.95 1000.5 333.66 833.8 166.95 833.8 166.95 1000.5"
  })), _polygon70 || (_polygon70 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "500.37 667.09 667.08 833.8 667.08 667.09 500.37 667.09"
  })), _polygon71 || (_polygon71 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "667.08 1000.5 667.08 833.8 500.37 1000.5 667.08 1000.5"
  })), _polygon72 || (_polygon72 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "500.37 667.09 333.66 833.8 500.37 833.8 500.37 667.09"
  })));
};
export default SvgFrLogoNew;